module.exports = __webpack_public_path__ + "img/csm_rosenstadt_f0c4877d19.d98d2c3b.jpg";